<script setup>
  import Hft_ContentBox from '@/components/microsites/HeadingForTomorrow/components/Hft_ContentBox.vue'
  import Hft_SectionWrapper from '@/components/microsites/HeadingForTomorrow/components/Hft_SectionWrapper.vue'
  import { gsap } from 'gsap'
  import { ScrollTrigger } from 'gsap/ScrollTrigger'
  import { onMounted, ref } from 'vue'
  gsap.registerPlugin(ScrollTrigger)
  const stars = ref([])
  function initStars() {
    const totalStars = 380
    const colors = ['white', '#5db4d1', 'white']
    const classSize = ['m-headingForT-sia__star--s', 'm-headingForT-sia__star--m', 'm-headingForT-sia__star--l']
    for (let i = 0; i < totalStars; i++) {
      const color = colors[Math.floor(Math.random() * colors.length)]
      const classForSIze = classSize[Math.floor(Math.random() * colors.length)]
      stars.value.push({
        id: i,
        top: Math.floor(Math.random() * 100),
        left: Math.floor(Math.random() * 100),
        delay: Math.floor(Math.random() * 5),
        duration: 3 + Math.floor(Math.random() * 4),
        color,
        classForSIze,
      })
    }
  }
  onMounted(() => {
    initStars()
    if (window.innerWidth >= 1024) {
      const tl_hero = gsap.timeline({
        scrollTrigger: {
          trigger: '.m-headingForT-sia-hero',
          start: 'top 70%', // when the top of the element hits 80% of the viewport height
          toggleActions: 'play none none none',
          onEnter: () => {
            setTimeout(() => {
              document
                .querySelectorAll('.m-headingForT-sia__stargroup')
                .forEach((el) => el.classList.add('m-headingForT-sia__stargroup--blinking'))
            }, 3000)
          },
        },
      })
      tl_hero
        .fromTo(
          '.m-headingForT-sia-hero__sia-img',
          { scale: 1.3, opacity: 0 },
          {
            x: '0',
            y: '0',
            scale: 1,
            opacity: 1,
            duration: 1.1,
            ease: 'power2.out',
          },
          '<'
        )
        .fromTo(
          '.m-headingForT-sia-hero__title',
          { scale: 1.15, opacity: 0 },
          {
            scale: 1,
            opacity: 1,
            duration: 1,
            ease: 'power2.out',
            delay: 0.2,
          },
          '<'
        )
        .fromTo(
          '.m-headingForT-sia__stargroup--1, .m-headingForT-sia__stargroup--2, .m-headingForT-sia__stargroup--3',
          { x: '-400%', scale: 3, opacity: 0 },
          {
            x: '0',
            scale: 1,
            opacity: 0.7,
            duration: 1.1,
            ease: 'power2.out',
          },
          '<'
        )
        .fromTo(
          '.m-headingForT-sia__stargroup--4, .m-headingForT-sia__stargroup--5',
          { x: '400%', scale: 3, opacity: 0 },
          {
            x: '0',
            scale: 1,
            opacity: 0.7,
            duration: 1.1,
            ease: 'power2.out',
          },
          '<'
        )
        .fromTo(
          '.m-headingForT-sia-hero .m-headingForT__sub-title',
          { scale: 1.15, opacity: 0 },
          {
            scale: 1,
            opacity: 1,
            duration: 1,
            ease: 'power2.out',
            delay: 0.2,
          },
          '<'
        )
        .fromTo(
          '.m-headingForT-sia-hero__stat',
          { scale: 1.15, opacity: 0 },
          {
            scale: 1,
            opacity: 1,
            duration: 1,
            ease: 'power2.out',
          },
          '<'
        )

      const tl_box1 = gsap.timeline({
        scrollTrigger: {
          trigger: '.m-headingForT-sia-box1-wrapper',
          start: 'top 40%', // when the top of the element hits 80% of the viewport height
          toggleActions: 'play none none none',
        },
      })
      tl_box1
        .fromTo(
          '.m-headingForT-sia-box1-wrapper',
          { scale: 1.15, opacity: 0 },
          { scale: 1, opacity: 1, duration: 2, ease: 'power2.out' },
          '<'
        )
        .fromTo(
          '.m-headingForT-sia__deco-fox',
          { scale: 1.15, opacity: 0 },
          { scale: 1, opacity: 1, delay: 1, duration: 2, ease: 'power2.out' },
          '<'
        )

      // .fromTo(
      //     '.m-headingForT-sia__deco-fox',
      //     { scale: 1.6, opacity: 0 },
      //     { scale: 1, opacity: 1, duration: 2, ease: 'power2.out' },
      //     '<'
      //   )
      // tl_box2
      const tl_box2 = gsap.timeline({
        scrollTrigger: {
          trigger: '.m-headingForT-sia__mid-texts',
          start: 'top 60%', // when the top of the element hits 80% of the viewport height
          toggleActions: 'play none none none',
        },
      })

      tl_box2
        .fromTo(
          '.m-headingForT-sia__mid-texts',
          { scale: 1.15, opacity: 0 },
          { scale: 1, opacity: 1, duration: 2, ease: 'power2.out' },
          '<'
        )
        .fromTo(
          '.m-headingForT-sia__deco-butterfly',
          { scale: 1.6, opacity: 0 },
          { scale: 1, opacity: 1, duration: 2, ease: 'power2.out' },
          '<'
        )
        .fromTo(
          '.m-headingForT-sia-box2-wrapper',
          { scale: 1.15, opacity: 0 },
          { scale: 1, opacity: 1, duration: 2, ease: 'power2.out' },
          '<'
        )

      const tl_box3 = gsap.timeline({
        scrollTrigger: {
          trigger: '.m-headingForT-sia-box3-wrapper',
          start: 'top 70%', // when the top of the element hits 80% of the viewport height
          toggleActions: 'play none none none',
        },
      })

      tl_box3.fromTo(
        '.m-headingForT-sia-box3-wrapper',
        { scale: 1.15, opacity: 0 },
        { scale: 1, opacity: 1, duration: 2, ease: 'power2.out' },
        '<'
      )
    }
  })
</script>

<template>
  <Hft_SectionWrapper class="m-headingForT-sia">
    <div class="m-headingForT-sia__stars">
      <div v-for="n in 5" :key="n" :class="`m-headingForT-sia__stargroup m-headingForT-sia__stargroup--${n}`"></div>
      <div class="m-headingForT-sia__deco-fox"></div>
      <div class="m-headingForT-sia__deco-butterfly"></div>
      <div
        v-for="star in stars"
        :key="star.id"
        class="m-headingForT-sia__star"
        :class="star.classForSIze"
        :style="{
          top: star.top + '%',
          left: star.left + '%',
          animationDelay: star.delay + 's',
          animationDuration: star.duration + 's',
          background: star.color,
          boxShadow: `0 0 1.9vw 0.2vw ${star.color}`,
        }"
      ></div>
    </div>

    <div class="m-headingForT-sia__overal-content">
      <div class="m-headingForT-sia-hero">
        <div class="m-headingForT-sia-hero__sia-img"></div>
        <div class="m-headingForT-sia-hero__main-content">
          <img
            class="m-headingForT-sia-hero__title"
            src="@/assets/images/microsites/headingfortomorrow/sia-astelle/title.png"
            alt=""
          />
          <div class="m-headingForT__sub-title">Available Now!</div>
          <div class="m-headingForT-sia-hero__stat">
            <div class="m-headingForT-sia-hero__stat-item">
              <div class="m-headingForT-sia-hero__stat-item-name">Class</div>
              <div class="m-headingForT-sia-hero__stat-item-value">Magician</div>
            </div>
            <div class="m-headingForT-sia-hero__stat-item">
              <div class="m-headingForT-sia-hero__stat-item-name">Main Stat</div>
              <div class="m-headingForT-sia-hero__stat-item-value">Intelligence (INT)</div>
            </div>
            <div class="m-headingForT-sia-hero__stat-item">
              <div class="m-headingForT-sia-hero__stat-item-name">Primary Weapon</div>
              <div class="m-headingForT-sia-hero__stat-item-value">Celestial Light</div>
            </div>
            <div class="m-headingForT-sia-hero__stat-item">
              <div class="m-headingForT-sia-hero__stat-item-name">Secondary Weapon</div>
              <div class="m-headingForT-sia-hero__stat-item-value">Compass</div>
            </div>
          </div>
        </div>
      </div>

      <Hft_ContentBox class="m-headingForT-sia-box1-wrapper">
        <div class="m-headingForT-sia-box1">
          <div class="m-headingForT-sia-box1__text">
            When a strange, dark wish interrupts the Star Spirit’s work and the constellations vanish, Sia Astelle, the
            Star Guardian, journeys into Maple World to discover what threatens her divine work.
          </div>
          <div class="m-headingForT-sia-box1__video">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/xMjuvADd6Yo"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
          <div class="m-headingForT-sia-box1__text">
            Sia calls upon the Constellations to fuel her magic in battle. Each subsequent cast creates powerful combos
            to blast her foes into orbit!
          </div>
        </div>
      </Hft_ContentBox>

      <div id="Menu-v260" class="m-headingForT-sia__mid-texts">
        <div class="m-headingForT__title">Challenger World and Burning Events!</div>
        <div class="m-headingForT__sub-title">Available Now!</div>
      </div>

      <Hft_ContentBox class="m-headingForT-sia-box2-wrapper">
        <div class="m-headingForT-sia-box2">
          <div class="m-headingForT-sia-box2__logo"></div>
          <div class="m-headingForT-sia-box2__content">
            <div class="m-headingForT-sia-box2__ss"></div>
            <div class="m-headingForT-sia-box2__text">
              Challenger World is a limited-time world that gives powerful bonuses to your stats and a huge boost to EXP
              earned, with challenges to complete, bosses to slay, and more! Afterward you can World Leap to Interactive
              <span>or</span> Heroic worlds!
            </div>
          </div>
        </div>
      </Hft_ContentBox>

      <Hft_ContentBox class="m-headingForT-sia-box3-wrapper">
        <div class="m-headingForT-sia-box3">
          <div class="m-headingForT-sia-box3__img"></div>
          <div class="m-headingForT-sia-box3__text">
            Hyper Burning MAX is faster than ever, granting an additional <span>4</span> bonus levels for every
            <span>1</span> you earn, all the way up to Lv. 260! Plus other returning Burning events boost your rewards
            in no time!
          </div>
        </div>
      </Hft_ContentBox>
      <a
        href="https://www.nexon.com/maplestory/news/events/27482/challenger-world-and-hyper-burning-max"
        target="_blank"
        ><Hft_Btn
      /></a>
    </div>
  </Hft_SectionWrapper>
</template>

<style lang="scss" scoped>
  @use '@/assets/scss/microsites/headingfortomorrow/fonts.scss' as *;
  @use '@/assets/scss/microsites/headingfortomorrow/variables.scss' as *;

  .m-headingForT-sia {
    background: url('~@/assets/images/microsites/headingfortomorrow/sia-astelle/bg.jpg') no-repeat center -6vw / 100% auto;
    text-align: center;
    padding-bottom: 5vw;
  }
  .m-headingForT-sia__stargroup {
    position: absolute;
    background: no-repeat center center / 100% auto;
  }
  .m-headingForT-sia__stargroup--blinking {
    animation: starGroupBlink infinite 2s;
  }
  .m-headingForT-sia__stargroup--1 {
    top: 13vw;
    left: 13vw;
    width: 7vw;
    height: 8vw;
    background-image: url('~@/assets/images/microsites/headingfortomorrow/sia-astelle/star-group1.png');
    animation-duration: 4s;
  }

  .m-headingForT-sia__stargroup--2 {
    top: 28vw;
    left: 3vw;
    width: 12vw;
    height: 12vw;
    background-image: url('~@/assets/images/microsites/headingfortomorrow/sia-astelle/star-group2.png');
    animation-duration: 4.5s;
  }
  .m-headingForT-sia__stargroup--3 {
    top: 45vw;
    left: 11vw;
    width: 10vw;
    height: 12vw;
    background-image: url('~@/assets/images/microsites/headingfortomorrow/sia-astelle/star-group3.png');
    animation-duration: 4.1s;
  }

  .m-headingForT-sia__stargroup--4 {
    top: 5vw;
    right: 7vw;
    width: 11vw;
    height: 18vw;
    background-image: url('~@/assets/images/microsites/headingfortomorrow/sia-astelle/star-group4.png');
    animation-duration: 4.8s;
  }

  .m-headingForT-sia__stargroup--5 {
    top: 38vw;
    right: 12vw;
    width: 10vw;
    height: 11vw;
    background-image: url('~@/assets/images/microsites/headingfortomorrow/sia-astelle/star-group5.png');
    animation-duration: 4.2s;
  }

  .m-headingForT-sia__stars {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 155vw;
    overflow: hidden;
  }

  .m-headingForT-sia__star {
    position: absolute;
    background: white;
    border-radius: 50%;
    opacity: 0;
    animation: starBlink infinite;
    box-shadow: 0 0 5px 2px white;
  }
  .m-headingForT-sia__star--s {
    width: 0.15vw;
    height: 0.15vw;
  }
  .m-headingForT-sia__star--m {
    width: 0.2vw;
    height: 0.2vw;
  }
  .m-headingForT-sia__star--l {
    width: 0.25vw;
    height: 0.25vw;
  }

  @keyframes starBlink {
    0%,
    100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @keyframes starGroupBlink {
    60% {
      opacity: 0.7;
    }
    80% {
      opacity: 1;
    }
    90% {
      opacity: 0;
    }
    100% {
      opacity: 0.7;
    }
  }

  .m-headingForT-sia__deco-fox {
    position: absolute;
    width: 20vw;
    height: 35vw;
    left: 0;
    top: 68vw;
    background: url('~@/assets/images/microsites/headingfortomorrow/sia-astelle/deco-fox.png') no-repeat center top /
      100% auto;
  }
  .m-headingForT-sia__deco-butterfly {
    position: absolute;
    width: 34vw;
    height: 36vw;
    right: 0vw;
    top: 96vw;
    background: url('~@/assets/images/microsites/headingfortomorrow/sia-astelle/deco-butterfly.png') no-repeat right -2vw
      top/100% auto;
  }
  .m-headingForT-sia__overal-content {
    max-width: 100%;
    /* position: relative; */
    overflow: hidden;
  }
  .m-headingForT-sia-hero {
    width: 100%;
    overflow: hidden;
  }
  .m-headingForT-sia-hero__sia-img {
    width: 47vw;
    height: 46vw;
    position: absolute;
    right: 13vw;
    top: -5.5vw;
    background: url('~@/assets/images/microsites/headingfortomorrow/sia-astelle/sia.png') no-repeat center top / 100%
      auto;
  }
  .m-headingForT-sia-hero__main-content {
    width: 28vw;
    margin: 0 auto;
    transform: translateX(-50%);
  }
  .m-headingForT-sia-hero__title {
    width: 100%;
    height: auto;
    margin-bottom: 1vw;
  }

  .m-headingForT-sia-hero__stat {
    margin: 1.6vw auto 2vw;
    width: 22.5vw;
  }
  .m-headingForT-sia-hero__stat-item {
    border: 1px white solid;
    display: flex;
    justify-content: center;
    margin-bottom: 0.2vw;
    font-size: 1.05vw;
  }
  .m-headingForT-sia-hero__stat-item-name {
    background: white;
    font-weight: bold;
    color: #3737c6;
    flex: 1;
    padding: 0.1vw 0;
  }
  .m-headingForT-sia-hero__stat-item-value {
    flex: 1;
    padding: 0.1vw 0;
    background: rgba(#191b3d, 0.5);
  }

  .m-headingForT-sia-box1__text {
    width: 40vw;
    margin: 0 auto;
  }
  .m-headingForT-sia-box1__video {
    border: 1px solid #80d8ff;
    display: inline-block;
    width: 47vw;
    height: 26vw;
    margin: 1.3vw 0 1vw;
    overflow: hidden;
    box-shadow: 0 0 20px rgba(0, 255, 255, 0.2), 0 0 0.6vw rgba(255, 255, 255, 0.4);
    iframe {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .m-headingForT-sia__mid-texts {
    margin: 11vw auto 0;
    width: 36vw;
  }
  .m-headingForT-sia-box2-wrapper {
    margin-bottom: 6.5vw;
  }

  .m-headingForT-sia-box2__logo {
    position: absolute;
    width: 51vw;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    height: 23vw;
    margin: 0 auto 1.5vw;
    background: url('~@/assets/images/microsites/headingfortomorrow/sia-astelle/box2/logo.png') no-repeat center top /
      100% auto;
  }
  .m-headingForT-sia-box2__content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 2vw;
    padding-top: 22vw;
  }
  .m-headingForT-sia-box2__ss {
    width: 24vw;
    height: 15vw;
    /* margin: 0 auto; */
    background: url('~@/assets/images/microsites/headingfortomorrow/sia-astelle/box2/ss.png') no-repeat center center /
      100% auto;
  }

  .m-headingForT-sia-box2__text {
    width: 20vw;
    text-align: left;
    span {
      color: #81d6ff;
      font-weight: bold;
    }
  }
  .m-headingForT-sia-box3-wrapper {
    margin-bottom: 4.5vw;
  }
  .m-headingForT-sia-box3 {
    position: relative;
    padding-top: 27vw;
  }
  .m-headingForT-sia-box3__img {
    position: absolute;
    left: 50%;
    top: -5.2vw;
    transform: translateX(-54%);
    width: 67vw;
    height: 33.5vw;
    margin: 0 auto;
    background: url('~@/assets/images/microsites/headingfortomorrow/sia-astelle/box3/burning-max-img.png') no-repeat
      center center / 100% auto;
  }

  .m-headingForT-sia-box3__text {
    text-align: center;
    span {
      color: #81d6ff;
      font-weight: bold;
    }
  }

  .tablet {
    .m-headingForT-sia__stars {
      display: none;
    }
    .m-headingForT-sia {
      background: url('~@/assets/images/microsites/headingfortomorrow/sia-astelle/bg-tablet.jpg') no-repeat center top/
        100% auto;
      text-align: center;
      padding-bottom: 12vw;
    }
    .m-headingForT-sia__stars {
      height: 306vw;
    }
    .m-headingForT-sia__star--s {
      width: 0.25vw;
      height: 0.25vw;
    }
    .m-headingForT-sia__star--m {
      width: 0.35vw;
      height: 0.35vw;
    }
    .m-headingForT-sia__star--l {
      width: 0.45vw;
      height: 0.45vw;
    }
    .m-headingForT-sia__deco-butterfly,
    .m-headingForT-sia__deco-fox {
      display: none;
    }
    .m-headingForT-sia-hero__sia-img {
      width: 76vw;
      height: 82vw;
      position: absolute;
      right: auto;
      left: 0;
      top: -5vw;
      background-position: left -16vw top;
    }
    .m-headingForT-sia-hero__title {
      margin-bottom: 3vw;
    }
    .m-headingForT-sia-hero__stat {
      margin: 3.3vw auto 3vw;
      width: 87%;
    }
    .m-headingForT-sia-hero__stat-item {
      font-size: 1.9vw;
      margin-bottom: 1vw;
    }
    .m-headingForT-sia-hero__stat-item-name,
    .m-headingForT-sia-hero__stat-item-value {
      padding: 0.5vw 0;
    }
    .m-headingForT-sia-hero__main-content {
      width: 46.5vw;
      transform: translateX(51%);
    }
    .m-headingForT-sia-box1-wrapper {
      margin-bottom: 18vw;
    }
    .m-headingForT-sia-box1__text {
      width: 77vw;
      margin: 0 auto;
    }
    .m-headingForT-sia-box1__video {
      margin: 2.3vw 0 2vw;
      width: 88vw;
      height: 49.5vw;
    }
    .m-headingForT-sia__mid-texts {
      width: 70%;
    }
    .m-headingForT-sia-box2__content {
      padding-top: 42vw;
      gap: 2.8vw;
    }
    .m-headingForT-sia-box2__logo {
      width: 93vw;
      height: 42vw;
      top: 0.5vw;
    }
    .m-headingForT-sia-box2__ss {
      width: 46vw;
      height: 30vw;
    }
    .m-headingForT-sia-box2__text {
      width: 36vw;
    }
    .m-headingForT-sia-box3__img {
      width: 106vw;
      height: 57vw;
      top: -8vw;
      background-size: 112% auto;
    }
    .m-headingForT-sia-box3 {
      padding-top: 47.8vw;
    }
  }

  .mobile {
    .m-headingForT-sia__stars {
      display: none;
    }
    .m-headingForT-sia {
      padding-bottom: 15vw;
      background: url('~@/assets/images/microsites/headingfortomorrow/sia-astelle/bg-mobile.jpg') no-repeat center top/
        100% auto;
    }

    .m-headingForT-sia__stars {
      height: 356vw;
    }

    .m-headingForT-sia__star--s {
      width: 0.4vw;
      height: 0.4vw;
    }
    .m-headingForT-sia__star--m {
      width: 0.5vw;
      height: 0.5vw;
    }
    .m-headingForT-sia__star--l {
      width: 0.7vw;
      height: 0.7vw;
    }
    .m-headingForT-sia__deco-butterfly,
    .m-headingForT-sia__deco-fox {
      display: none;
    }
    .m-headingForT-sia-hero__sia-img {
      width: 100%;
      height: 126vw;
      right: auto;
      left: 50%;
      transform: translateX(-50%) !important;
      top: -17vw;
      background: url('~@/assets/images/microsites/headingfortomorrow/sia-astelle/sia-mobile.png') no-repeat center top /
        129% auto;
    }
    .m-headingForT-sia-hero__title {
      width: 79vw;
      margin-bottom: 3vw;
    }
    .m-headingForT-sia-hero__main-content {
      width: 95%;
      margin-top: 60vw;
      transform: none;
      z-index: 1;
      position: relative;
    }
    .m-headingForT-sia-hero__stat {
      margin-top: 4vw;
      width: 100%;
    }
    .m-headingForT-sia-hero__stat-item {
      font-size: 4.8vw;
      border: 2px white solid;
      margin-bottom: 1.5dvw;
    }
    .m-headingForT-sia-hero__stat-item-name,
    .m-headingForT-sia-hero__stat-item-value {
      padding: 1.8vw 0;
    }
    .m-headingForT-sia-box1__text {
      width: 80vw;
    }
    .m-headingForT-sia-box1__video {
      width: 86vw;
      height: 47vw;
      margin: 3vw 0 2vw;
    }
    .m-headingForT-sia__mid-texts {
      width: 79vw;
    }
    .m-headingForT-sia-box1-wrapper {
      margin-bottom: 17vw;
    }
    .m-headingForT-sia-box2__text {
      width: 94%;
      text-align: center;
    }
    .m-headingForT-sia-box2__logo {
      width: 92vw;
      height: 46vw;
      top: 2vw;
    }
    .m-headingForT-sia-box2-wrapper {
      margin-bottom: 11vw;
    }
    .m-headingForT-sia-box2__content {
      padding-top: 47vw;
    }
    .m-headingForT-sia-box2__ss {
      width: 65vw;
      height: 40vw;
      margin-bottom: 2vw;
    }
    .m-headingForT-sia-box3 {
      padding-top: 46vw;
    }
    .m-headingForT-sia-box3__img {
      width: 100vw;
      height: 70vw;
      top: -14.5vw;
    }
  }
</style>
